import { useEffect } from 'react'

import { logSentry } from '@gto/sentry'
import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

type Props = {
  error?: unknown
}

export const DefaultErrorPage = ({ error }: Props) => {
  // Capture unhandled render errors that TanStack Router caught and routed
  // here. Without this, every render crash in the admin app is invisible
  // in production.
  useEffect(
    function captureRenderError() {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- framework-delivered error arrival, not a user event: TanStack Router's error boundary caught a render crash and mounted this page with the error prop. There is no interaction and no handler that owns "the router routed a caught error here", so the capture belongs in an effect; the [error] dep dedupes on error identity.
      if (error !== undefined) {
        logSentry('admin-web: unhandled render error', error)
      }
    },
    [error],
  )

  return (
    <div className="flex size-full min-h-[100dvh] flex-col items-center justify-center gap-6 p-6">
      <Typography
        color="primary"
        variant="h1"
      >
        Oops!
      </Typography>
      <Typography
        color="text.primary"
        variant="h5"
      >
        Something went wrong.
      </Typography>
      <Typography
        color="text.secondary"
        variant="body2"
      >
        An unexpected error occurred while rendering this page.
      </Typography>
      <Button
        color="primary"
        variant="contained"
        onClick={() => {
          window.location.reload()
        }}
      >
        Reload the page
      </Button>
    </div>
  )
}
